import { invokeApi } from "../../bl_libs/invokeApi";

const auth = () => ({ "x-sh-auth": localStorage.getItem("token") });

// GET /api/admin/user/:userId/tokens
// Returns { balance, allocationBalance, purchasedBalance, explanationCredits }
export const admin_get_user_tokens_api = async (userId) => {
  return invokeApi({ path: `api/admin/user/${userId}/tokens`, method: "GET", headers: auth() });
};

// POST /api/admin/user/adjust-tokens
// body: { userId, amount (positive = add, negative = deduct), reason }
export const admin_adjust_tokens_api = async (userId, amount, reason) => {
  return invokeApi({
    path: "api/admin/user/adjust-tokens",
    method: "POST",
    headers: auth(),
    postData: { userId, amount, reason },
  });
};

// POST /api/admin/user/charge-credits
// Charges user's default Stripe card for creditAmount credits
// body: { userId, creditAmount }
export const admin_charge_credits_api = async (userId, creditAmount) => {
  return invokeApi({
    path: "api/admin/user/charge-credits",
    method: "POST",
    headers: auth(),
    postData: { userId, creditAmount },
  });
};

// POST /api/admin/user/resume-pause
// Removes the user's active data pause (keeps their data)
// body: { userId }
export const admin_resume_pause_api = async (userId) => {
  return invokeApi({
    path: "api/admin/user/resume-pause",
    method: "POST",
    headers: auth(),
    postData: { userId },
  });
};

// GET /api/admin/user/:userId/lessons
// Returns { total (decimal), completedCount, inProgressCount, inProgress[], bySubject[] }
export const admin_get_user_lessons_api = async (userId) => {
  return invokeApi({ path: `api/admin/user/${userId}/lessons`, method: "GET", headers: auth() });
};
